import { useQuery } from "@tanstack/react-query";
import { buyerSendVersionsApi } from "@/api/buyerSendVersions";
import { sendVersionKeys } from "./sendVersionKeys";

/**
 * One submission's send history — every intro email and every package that
 * actually went out.
 *
 * <p>Read-only by design. There is no mutation here and there must not be one:
 * a version is appended by the SEND paths, and re-sending an old version goes
 * back down the ordinary send endpoint. That is what keeps
 * `PackageSentAtUtc`'s single forward-only writer single — a write on this
 * surface would be a second one.</p>
 *
 * <p>Freshness comes from the send mutations, which already invalidate
 * `buyerSubmissionKeys.all`; `sendVersionKeys` hangs beneath it, so a send
 * refreshes the history it just added to with no extra invalidation to
 * remember.</p>
 */
export function useSendHistory(submissionId: string) {
  return useQuery({
    queryKey: sendVersionKeys.forSubmission(submissionId),
    queryFn: () => buyerSendVersionsApi.history(submissionId),
    enabled: Boolean(submissionId),
  });
}
